<template>
    <div id="dataset">
        <p class="view-title">数据集</p>
        <div class="organize">
            <organize @setOrId="setOrId(arguments)" :recoveryName="recoveryName" @setTree="setTree"></organize>
        </div>
        <!-- 列表 -->
        <div class="list-box" style="top: 77px;">
            <header class="tabs-box clearfix">
                <div :class="{'active':state==0}" @click="headClick(0)" id="headClick0"><span>全部</span></div>
                <div :class="{'active':state==3}" @click="headClick(3)" id="headClick3"><span>通用</span></div>
                <div :class="{'active':state==4}" @click="headClick(4)" id="headClick4"><span>自定义</span></div>
            </header>
            <div class="bg">
                <div class="list-top clearfix">
                    <el-button type="primary" class="add-btn" @click="addDataset" :disabled="!functionSet.includes('datasetEdit')||$store.state.isLook" id="addDatasetBtn">新增数据集</el-button>
                    <div class="search-btn">
                        <el-button type="primary" class="add-btn" @click="search" id="searchBtn">搜索</el-button>
                        <!-- <el-button type="primary" class="add-btn" @click="createdExcel" id="createdExcel" >生成报表</el-button> -->
                    </div>
                    <div class="search">
                        <el-input
                            placeholder="请输入数据集名称"
                            v-model="searchVal" class="search-input" id="searchDatasetVal" @keyup.enter.native="search">
                            <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                    </div>
                    <div class="f-r select-box2">
                      <span>数据集分类：</span>
                      <el-cascader :options="dataSetCategory" :show-all-levels="false" :props="optionProps" class="cascader f-r" v-model="categoryId">
                        <template slot-scope="{ node, data }">
                          <span>{{data.name}}</span>
                        </template>
                      </el-cascader>
                    </div>
                </div>
                <div class="company-list clearfix">
                    <ul class="list-title">
                        <li class="w-18">数据集名称</li>
                        <li>数据集类型</li>
                        <li>所属组织</li>
                        <!-- <li>状态</li> -->
                        <!-- <li>引用计数</li> -->
                        <li class="w-18">备注</li>
                        <li class="min-120">操作</li>
                    </ul>
                    <div class="scroll">
                        <el-checkbox-group v-model="checkObj">
                            <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
                              <!-- <el-checkbox :label="item" :class="{'currency':item.type==1}" :disabled="item.state==2||item.type==1&&orSuperior.type!=3||item.frameType==3">{{''}}</el-checkbox> -->
                                <li :title="item.name" class="w-18"><i class="typeicon"><img :src="item.type==1?dataset1:dataset"></i>{{item.name}}</li>
                                <li :title="item.type==1?'通用':'自定义'+'数据集'">{{item.type==1?"通用":"自定义"}}数据集</li>
                                <li :title="item.groupName">{{item.groupName}}</li>
                                <!-- <li :class="{'color-red':item.state != 1}">{{item.state==1?'启用':'停用'}}</li> -->
                                <!-- <li>{{item.referenceCount}}</li> -->
                                <li :title="item.title" class="w-18">{{item.note}}</li>
                                <li class="operate min-120">
                                    <span @click="operate(item,'editDatasetShow',i)" :id="`editDataset${i}`">{{testFunc(item)&&!$store.state.isLook?'编辑':'查看'}}</span>
                                    <span :class="{'disabled':!testFunc(item)||$store.state.isLook}" @click="operate(item,'delDatasetShow',i)" :id="`delDataset${i}`">删除</span>
                                </li>
                            </ul>
                        </el-checkbox-group>
                    </div>
                </div>
                <!-- 没有列表数据 -->
                <div class="nullDataBox" v-show="dataList.length==0">
                    <img :src="nullData" class="nullData">
                    <span>什么东西都没有找到...</span>
                </div>
            </div>
            <!-- 分页 -->
            <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
            <!-- 弹窗 -->
            <div class="popup">
                <!-- 删除数据集 -->
                <div class="popup-delDataset" v-show="delDatasetShow">
                    <div class="popup-title">
                        删除数据集<i class="el-icon-circle-close close" @click="close('delDatasetShow')" id="closeDel1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        系统将删除该数据集"{{nowObj.name}}",是否继续？
                        <p class="popup-btn-box"><el-button type="primary" id="delDataset" :disabled="!functionSet.includes('datasetEdit')" @click="delDataset">确定</el-button> <el-button @click="close('delDatasetShow')" id="closeDel2">取消</el-button></p>
                    </div>
                </div>
                <!-- 新增数据集 -->
                <div class="popup-addDataset" v-show="addDatasetShow">
                    <div class="popup-title">
                        新增数据集<i class="el-icon-circle-close close" @click="close('addDatasetShow')" id="closeAdd1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        <el-form :rules="rules" ref="addDatasetForm" class="clearfix" :model="ruleForm" :disabled="!functionSet.includes('datasetEdit')">  <!---->
                            <div class="ruleFrom-left">
                                <el-form-item prop="name" label="数据集名称：" autocomplete="off" >
                                    <i><img :src="notes" title="数据集名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                    <el-input v-model="ruleForm.name"></el-input>
                                </el-form-item>
                                <el-form-item label="运算类型：" autocomplete="off" prop="type">
                                    <el-radio-group v-model="ruleForm.simple" class="m-l-10" @change='changeRuleType' style="margin-right: 25px;">
                                        <el-radio :label="1">单一</el-radio>
                                        <el-radio :label="2">复合</el-radio>
                                    </el-radio-group>
                                    函数：
                                    <el-select v-model="ruleForm.function" placeholder="请选择">  <!--@change="changeFunc" @change="changeFunction"-->
                                        <el-option value='sample' label="统计"></el-option>
                                        <el-option value='growth' label="环比" :disabled="ruleForm.simple==2"></el-option>
                                        <el-option value='ratio' label="同比" :disabled="ruleForm.simple==2"></el-option>
                                        <el-option value='pass' label="透传"></el-option>
                                        <el-option value='add' label="加"></el-option>
                                        <el-option value='subtract' label="减"></el-option>
                                        <el-option value='multiply' label="乘"></el-option>
                                        <el-option value='divide' label="除"></el-option>
                                        <!-- <el-option value='time' label="持续时间"></el-option> -->
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="数据集类别：" autocomplete="off" prop="categoryId">
                                  <el-cascader :options="CategoryList" :show-all-levels="false" :props="optionProps" class="cascader" v-model="ruleForm.categoryId">
                                    <template slot-scope="{ node, data }">
                                      <span>{{data.name}}</span>
                                    </template>
                                  </el-cascader>
                                </el-form-item>
                            </div>
                            <div class="ruleFrom-right">
                                <!-- <el-form-item label="时间段：" autocomplete="off" prop="frameType">
                                    <el-radio-group v-model="ruleForm.frameType" class="m-l-10" @change="changeFrameType">
                                        <el-radio :label="3">实时</el-radio>
                                        <el-radio :label="1">相对时间段</el-radio>
                                        <el-radio :label="2">指定时间段</el-radio>
                                    </el-radio-group>
                                    <div>
                                        <el-radio-group v-model="ruleForm.timeFrame" class="m-l-10" v-show="ruleForm.frameType==1" @change="changeTimeFrame">
                                            <el-radio :label="1">分</el-radio>
                                            <el-radio :label="2">时</el-radio>
                                            <el-radio :label="3">天</el-radio>
                                            <el-radio :label="4">周</el-radio>
                                            <el-radio :label="5">月</el-radio>
                                            <el-radio :label="6">季</el-radio>
                                            <el-radio :label="7">年</el-radio>
                                        </el-radio-group>
                                    </div>
                                    <div v-show="ruleForm.frameType==2">
                                        <div class="time-box f-l">
                                            <el-form-item label="" prop="beginFrame" autocomplete="off" :rules="rules.beginFrame" class="f-l w-220">
                                                <el-date-picker
                                                    v-model="ruleForm.beginFrame"
                                                    :editable="false"
                                                    type="date"
                                                    class="time m-r-12"
                                                    placeholder="选择日期"
                                                    :picker-options="pickerOptionsStart"
                                                    format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd"
                                                    @change='beginDate'>
                                                </el-date-picker>
                                            </el-form-item>
                                            <span style="margin: 0 5px;">至</span>
                                            <el-form-item label="" prop="endFrame" autocomplete="off" :rules="rules.endFrame" class="f-r w-220">
                                                <el-date-picker
                                                    v-model="ruleForm.endFrame"
                                                    :editable="false"
                                                    type="date"
                                                    class="time"
                                                    placeholder="选择日期"
                                                    :picker-options="pickerOptionsEnd"
                                                    format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd"
                                                    @change='endDate'>
                                                </el-date-picker>
                                            </el-form-item>
                                        </div>
                                    </div>
                                </el-form-item> -->
                                <!-- <el-form-item label="时间粒度：" autocomplete="off" prop="timeWindow" class="w-100 m-l-10" v-show="ruleForm.frameType!=2">
                                    <el-radio-group v-model="ruleForm.timeWindow" class="m-l-12" :disabled="ruleForm.frameType == 3">
                                        <el-radio :label="1" :disabled="ruleForm.timeFrame-2>1||1>ruleForm.timeFrame">分</el-radio>
                                        <el-radio :label="2" :disabled="ruleForm.timeFrame-2>2||2>ruleForm.timeFrame">时</el-radio>
                                        <el-radio :label="3" :disabled="ruleForm.timeFrame-2>3||3>ruleForm.timeFrame">天</el-radio>
                                        <el-radio :label="4" :disabled="ruleForm.timeFrame-2>4||4>ruleForm.timeFrame">周</el-radio>
                                        <el-radio :label="5" :disabled="ruleForm.timeFrame-2>5||5>ruleForm.timeFrame">月</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="时间粒度：" autocomplete="off" prop="timeWindow" class="w-100 m-l-10" v-show="ruleForm.frameType==2">
                                    <el-radio-group v-model="ruleForm.timeWindow" class="m-l-12">
                                        <el-radio :label="1" :disabled="cha-2>2||2>cha">分</el-radio>
                                        <el-radio :label="2" :disabled="cha-2>2||2>cha">时</el-radio>
                                        <el-radio :label="3" :disabled="cha-2>3||3>cha">天</el-radio>
                                        <el-radio :label="4" :disabled="cha-2>4||4>cha">周</el-radio>
                                        <el-radio :label="5" :disabled="cha-2>5||5>cha">月</el-radio>
                                    </el-radio-group>
                                </el-form-item> -->
                                <!-- <el-form-item label="修正系数：" autocomplete="off" >
                                    <el-input v-model="ruleForm.ratio" class="coefficient" @input="ruleForm.ratio=ruleForm.ratio.replace(/[^\-?\d.]/g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.').replace(/^\./g, '').replace(/--/g, '-');"></el-input>
                                </el-form-item> -->
                                <el-form-item label="数据集类型：" autocomplete="off" prop="type">
                                    <el-radio-group v-model="ruleForm.type" class="m-l-10" @change='changeRuleType'>
                                        <el-radio :label="2">自定义数据集</el-radio>
                                        <el-radio :label="1" :disabled="!functionSet.includes('datasetNormal')">通用数据集</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="所属组织：" prop="group" autocomplete="off" class="m-t-0">
                                    <!-- <i class="f-l"><img :src="notes" title="" class="notes"></i> -->
                                    <div class="popup-lab m-t-0" @mouseleave="selectShow=false" v-show="ruleForm.type==2&&functionSet.includes('datasetEdit')">
                                        <div class="or-Superior" @click='showSelect'>
                                            <span class="p-a-l-10">{{orSuperior.name}}</span>
                                            <i><img :src="down" @click="showSelect"></i>
                                            <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                                                <div class="dashed">
                                                    <el-tree :data="orSuperiorData" :indent='0' node-key="id" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                                        <span class="custom-tree-node" slot-scope="{ node, data }">
                                                            <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area" class="tree-icon"></i>
                                                            <span>{{ node.label }}<span v-if='data.roleName&&data.type!=3'>({{data.roleName}})</span></span>
                                                        </span>
                                                    </el-tree>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="popup-lab m-t-0" v-show="ruleForm.type==1||!functionSet.includes('datasetEdit')">
                                        <div class="or-Superior disabled3">
                                            <span class="p-a-l-10">{{orSuperior.name}}</span>
                                            <i><img :src="down"></i>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="输出格式：" autocomplete="off" style="margin-top: 15px;">
                                    <el-form-item label="" class="w-30" autocomplete="off" prop="place" :rules="rules.place">
                                        <span>小数点后保留<el-input class="place" v-model="ruleForm.place" @input="ruleForm.place=ruleForm.place.replace(/[^\d]/g,'')"></el-input>位</span>
                                    </el-form-item>
                                    <span class="f-r unit-select">单位：
                                        <el-select v-model="ruleForm.unit" filterable placeholder="请选择单位" @change="chanegUnit" style="width: 80%; float: right;">
                                            <el-option
                                            v-for="item in unitData"
                                            :key="item.Symbol"
                                            :label="`${item.Name+'/'+item.Symbol}`"
                                            :value="item.Symbol">
                                            </el-option>
                                        </el-select>
                                    </span>
                                </el-form-item>
                            </div>
                            <div class="ruleFrom-bottom">
                              <div class="clearfix">
                                <header class="tabs-box2 clearfix" v-show="ruleForm.simple==2">
                                  <div :class="{'active':subsetIndex==s}" v-for="subset,s in ruleForm.subset" @click="subsetIndex=s"><span>子集{{s+1}}</span> <i @click.stop="delSubset(s)" class="del-icon el-icon-delete" v-if="s"></i></div>
                                </header>
                                <div class="add-state" @click="addSubset" :class="{disabled:ruleForm.subset.length>9}" v-show="ruleForm.simple==2">添加子集</div>
                              </div>
                              <div class="data-orange-box" v-for="item,i in ruleForm.subset" v-show="subsetIndex==i" v-if="ruleForm.simple==1?i==0:true">
                                  <div class="name-box clearfix">
                                    <el-form-item label="显示名：" style="float: left; width: 300px !important" autocomplete="off" :prop="'subset.' + i + '.name'" :rules="{required: true, message: '显示名不能为空', trigger: 'change'}">
                                      <el-input v-model="item.name" style="width:202px;margin-right: 15px;"></el-input>
                                    </el-form-item>
                                    <el-form-item label="函数：" style="float: left; width: 300px !important;" autocomplete="off" v-show="ruleForm.simple==2">
                                      <el-select v-model="item.function" placeholder="请选择">  <!--@change="changeFunc" @change="changeFunction"-->
                                          <el-option value='sample' label="统计"></el-option>
                                          <el-option value='growth' label="环比"></el-option>
                                          <el-option value='ratio' label="同比"></el-option>
                                          <el-option value='pass' label="透传"></el-option>
                                          <el-option value='add' label="加"></el-option>
                                          <el-option value='subtract' label="减"></el-option>
                                          <el-option value='multiply' label="乘"></el-option>
                                          <el-option value='divide' label="除"></el-option>
                                          <!-- <el-option value='time' label="持续时间"></el-option> -->
                                      </el-select>
                                    </el-form-item>
                                  </div>
                                  <div v-for="(properties,p) in item.properties" :key="p" class="orange-list">
                                      <el-form :rules="rules" class="clearfix" :model="item" ref="addDataOrigin">
                                          <span class="f-l">数据源{{p+1}}：</span>
                                              <!-- :disabled="orSuperior.type==3" -->
                                        <el-form-item label="" autocomplete="off" style="width: 150px !important; margin-left: 12px; float: left;">
                                          <el-cascader
                                              :options="groupTree"
                                              :props="groupProps"
                                              :show-all-levels="false"
                                              v-model="properties.groupCode"
                                              :ref="'addCascader'+i+p"
                                              placeholder="请选择组织"
                                              @change="changeGroup(properties,'addCascader'+i+p)"
                                              ></el-cascader>
                                          </el-form-item>
                                          <el-form-item label="" autocomplete="off" style="width: 150px !important; float: left; margin-left: 12px;" :prop="'properties.' + p + '.type'" :rules="{required: true, message: '请选择属性类型', trigger: 'change'}">
                                            <el-select v-model="properties.type" placeholder="请选择属性类型" @change="changeType(properties,'addCascader'+i+p)" >
                                                <el-option :value="1" label="产品属性" :disabled="ruleForm.function == 'time'||ruleForm.function == 'growth'"></el-option>
                                                <el-option :value="2" label="设备属性" :disabled="ruleForm.type==1||properties.groupType!=3"></el-option>
                                                <el-option :value="3" label="系统属性"></el-option>
                                                <el-option :value="4" label="数值"></el-option>
                                            </el-select>
                                          </el-form-item>

                                          <el-form-item label="" v-if="properties.type!=4" autocomplete="off" style="width: 150px !important; margin-left: 12px; float: left;" :prop="'properties.'+p+'.code'" :rules="{required: true, message: '请选择属性', trigger: 'change'}">
                                            <el-select v-model="properties.code" placeholder="请选择属性" @change="changeCode(properties)">
                                                <el-option
                                                :key="properties.VirtualDeviceCode"
                                                label="虚拟设备"
                                                :value="properties.VirtualDeviceCode"
                                                v-show="properties.type==2">
                                                </el-option>
                                                <el-option
                                                v-for="devObj in deviceList"
                                                :key="devObj.code"
                                                :label="devObj.name"
                                                v-if="orSuperior.type==3"
                                                :value="devObj.code">
                                                </el-option>
                                                <el-option
                                                v-for="devObj in systemList"
                                                :key="devObj.code"
                                                v-if="properties.type==3"
                                                :label="devObj.name"
                                                :value="devObj.code">
                                                </el-option>
                                                <el-option
                                                v-for="devObj in properties.deviceList"
                                                :key="devObj.code"
                                                v-if="properties.type==2&&orSuperior.type!=3"
                                                :label="devObj.name"
                                                :value="devObj.code">
                                                </el-option>
                                                <el-option
                                                v-for="devObj in allProductData"
                                                :key="devObj.code"
                                                v-if="properties.type==1"
                                                :label="devObj.name"
                                                :value="devObj.code">
                                                </el-option>
                                            </el-select>
                                          </el-form-item>
                                          <el-form-item label="" v-if="properties.type!=4" autocomplete="off" style="width: 150px !important; float: left; margin-left: 12px;" :prop="'properties.'+p+'.property'" :rules="{required: true, message: '请选择属性类型', trigger: 'change'}">
                                            <el-select v-model="properties.property" placeholder="请选择" @change="$forceUpdate()">
                                                <el-option
                                                v-for="devObj in properties.propertyData"
                                                :key="devObj.identifier"
                                                :label="devObj.name"
                                                :value="devObj.identifier"
                                                v-if="properties.code!=properties.VirtualDeviceCode"
                                                >
                                                </el-option>
                                                <el-option
                                                v-for="devObj in properties.VirtualFuncList"
                                                :key="devObj.identifier"
                                                :label="devObj.name"
                                                :value="devObj.identifier"
                                                v-if="properties.code==properties.VirtualDeviceCode"
                                                >
                                                </el-option>
                                            </el-select>
                                          </el-form-item>
                                          <el-form-item label="" v-if="properties.type==1&&properties.groupType==3" autocomplete="off" style="width: 150px !important; float: left; margin-left: 12px;" :prop="'properties.'+p+'.extend'" :rules="rules.groupType">
                                            <el-cascader
                                                :options="properties.DeviceGroup"
                                                :props="deviceGroupProps"
                                                v-model="properties.extend"
                                                :show-all-levels="false"
                                                v-if="properties.DeviceGroup"
                                            ></el-cascader>
                                          </el-form-item>

                                          <el-form-item label="" v-if="properties.type==4" autocomplete="off" style="width: 150px !important; float: left; margin-left: 12px;" :prop="'properties.'+p+'.extend'" :rules="{required: true, message:'请输入数值', trigger: 'change'}">
                                            <el-input v-model="properties.extend" @input="properties.extend=properties.extend.replace(/[^\-?\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"></el-input>
                                          </el-form-item>
                                          <span class="delAttr" @click="delproperties(p)" v-show="p>0">删除</span>
                                          <span class="delAttr disabled" v-show="p==0">删除</span>
                                      </el-form>
                                          <!-- <span>属&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;性：</span> -->
                                  </div>
                                  <span :class="[{'disabled':ruleForm.function=='time'},'add-enum']" @click="addProperties">+新增数据源</span>
                              </div>
                            </div>
                        </el-form>
                        <p class="popup-btn-box"><el-button type="primary" id="addDataset" @click="createdDataset('addDatasetForm')">确定</el-button> <el-button @click="close('addDatasetShow')" id="closeadd2">取消</el-button></p>
                    </div>
                </div>
                <!-- 编辑数据集 -->
                <div class="popup-addDataset" v-show="editDatasetShow">
                    <div class="popup-title">
                        {{functionSet.includes('datasetEdit')&&!$store.state.isLook?'编辑':'查看'}}数据集<i class="el-icon-circle-close close" @click="close('editDatasetShow')" id="closeEdit1"></i>
                    </div>
                    <div class="popup-lab t-left">
                        <el-form :rules="rules" ref="editDatasetForm" class="clearfix" :model="ruleForm" :disabled="!functionSet.includes('datasetEdit')">  <!---->
                            <div class="ruleFrom-left">
                                <el-form-item prop="name" label="数据集名称：" autocomplete="off" >
                                    <i><img :src="notes" title="数据集名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
                                    <el-input v-model="ruleForm.name"></el-input>
                                </el-form-item>
                                <el-form-item label="运算类型：" autocomplete="off" prop="type">
                                    <el-radio-group v-model="ruleForm.simple" class="m-l-10" @change='changeRuleType' style="margin-right: 25px;">
                                        <el-radio :label="1">单一</el-radio>
                                        <el-radio :label="2">复合</el-radio>
                                    </el-radio-group>
                                    函数：
                                    <el-select v-model="ruleForm.function" placeholder="请选择">  <!--@change="changeFunc" @change="changeFunction"-->
                                        <el-option value='sample' label="统计"></el-option>
                                        <el-option value='growth' label="环比" :disabled="ruleForm.simple==2"></el-option>
                                        <el-option value='ratio' label="同比" :disabled="ruleForm.simple==2"></el-option>
                                        <el-option value='pass' label="透传"></el-option>
                                        <el-option value='add' label="加"></el-option>
                                        <el-option value='subtract' label="减"></el-option>
                                        <el-option value='multiply' label="乘"></el-option>
                                        <el-option value='divide' label="除"></el-option>
                                        <!-- <el-option value='time' label="持续时间"></el-option> -->
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="数据集类别：" autocomplete="off" prop="categoryId">
                                  <el-cascader :options="CategoryList" :show-all-levels="false" :props="optionProps" class="cascader" v-model="ruleForm.categoryId">
                                    <template slot-scope="{ node, data }">
                                      <span>{{data.name}}</span>
                                    </template>
                                  </el-cascader>
                                </el-form-item>
                            </div>
                            <div class="ruleFrom-right">
                                <el-form-item label="数据集类型：" autocomplete="off" prop="type">
                                    <el-radio-group v-model="ruleForm.type" class="m-l-10" @change='changeRuleType'>
                                        <el-radio :label="2">自定义数据集</el-radio>
                                        <el-radio :label="1" :disabled="!functionSet.includes('datasetNormal')">通用数据集</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="所属组织：" prop="group" autocomplete="off" class="m-t-0">
                                    <div class="popup-lab m-t-0" @mouseleave="selectShow=false" v-show="ruleForm.type==2&&functionSet.includes('datasetEdit')">
                                        <div class="or-Superior" @click='showSelect'>
                                            <span class="p-a-l-10">{{orSuperior.name}}</span>
                                            <i><img :src="down" @click="showSelect"></i>
                                            <div class="select-box tree" ref="selectbox" v-show='selectShow'>
                                                <div class="dashed">
                                                    <el-tree :data="orSuperiorData" :indent='0' node-key="id" ref="editTree" :highlight-current="true" :default-expand-all="true" :check-on-click-node="false" @node-click="selectId" :props="defaultProps">
                                                        <span class="custom-tree-node" slot-scope="{ node, data }">
                                                            <i><img :src="data.type == 1 ? branch : data.type == 2 ? location : area" class="tree-icon"></i>
                                                            <span>{{ node.label }}<span v-if='data.roleName&&data.type!=3'>({{data.roleName}})</span></span>
                                                        </span>
                                                    </el-tree>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="popup-lab m-t-0" v-show="ruleForm.type==1||!functionSet.includes('datasetEdit')">
                                        <div class="or-Superior disabled3">
                                            <span class="p-a-l-10">{{orSuperior.name}}</span>
                                            <i><img :src="down"></i>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="输出格式：" autocomplete="off" style="margin-top: 15px;">
                                    <el-form-item label="" class="w-30" autocomplete="off" prop="place" :rules="rules.place">
                                        <span>小数点后保留<el-input class="place" v-model="ruleForm.place" @input="ruleForm.place=ruleForm.place.replace(/[^\d]/g,'')"></el-input>位</span>
                                    </el-form-item>
                                    <span class="f-r unit-select">单位：
                                        <el-select v-model="ruleForm.unit" filterable placeholder="请选择单位" @change="chanegUnit" style="width: 80%; float: right;">
                                            <el-option
                                            v-for="item in unitData"
                                            :key="item.Symbol"
                                            :label="`${item.Name+'/'+item.Symbol}`"
                                            :value="item.Symbol">
                                            </el-option>
                                        </el-select>
                                    </span>
                                </el-form-item>
                            </div>
                            <div class="ruleFrom-bottom">
                              <div class="clearfix">
                                <header class="tabs-box2 clearfix" v-show="ruleForm.simple==2">
                                  <div :class="{'active':subsetIndex==s}" v-for="subset,s in ruleForm.subset" @click="subsetIndex=s"><span>子集{{s+1}}</span> <i @click.stop="delSubset(s)" class="del-icon el-icon-delete" v-show="s"></i></div>
                                </header>
                                <div class="add-state" @click="addSubset" :class="{disabled:ruleForm.subset.length>9}" v-show="ruleForm.simple==2">添加子集</div>
                              </div>
                              <div class="data-orange-box" v-for="item,i in ruleForm.subset" v-show="subsetIndex==i" v-if="ruleForm.simple==1?i==0:true">
                                  <div class="name-box clearfix">
                                    <el-form-item label="显示名：" style="float: left; width: 300px !important" autocomplete="off" :prop="'subset.' + i + '.name'" :rules="{required: true, message: '显示名不能为空', trigger: 'change'}">
                                      <el-input v-model="item.name" style="width:202px;margin-right: 15px;"></el-input>
                                    </el-form-item>
                                    <el-form-item label="函数：" style="float: left; width: 300px !important;" autocomplete="off" v-show="ruleForm.simple==2">
                                      <el-select v-model="item.function" placeholder="请选择">  <!--@change="changeFunc" @change="changeFunction"-->
                                          <el-option value='sample' label="统计"></el-option>
                                          <el-option value='growth' label="环比"></el-option>
                                          <el-option value='ratio' label="同比"></el-option>
                                          <el-option value='pass' label="透传"></el-option>
                                          <el-option value='add' label="加"></el-option>
                                          <el-option value='subtract' label="减"></el-option>
                                          <el-option value='multiply' label="乘"></el-option>
                                          <el-option value='divide' label="除"></el-option>
                                          <!-- <el-option value='time' label="持续时间"></el-option> -->
                                      </el-select>
                                    </el-form-item>
                                  </div>
                                  <div v-for="(properties,p) in item.properties" :key="p" class="orange-list">
                                      <el-form :rules="rules" class="clearfix" :model="item" ref="editDataOrigin">
                                          <span class="f-l">数据源{{p+1}}：</span>
                                              <!-- :disabled="orSuperior.type==3" -->
                                        <el-form-item label="" autocomplete="off" style="width: 150px !important; margin-left: 12px; float: left;">
                                          <el-cascader
                                              :options="groupTree"
                                              :props="groupProps"
                                              :show-all-levels="false"
                                              v-model="properties.groupCode"
                                              :ref="'editCascader'+i+p"
                                              placeholder="请选择组织"
                                              @change="changeGroup(properties,'editCascader'+i+p)"
                                              ></el-cascader>
                                          </el-form-item>
                                          <el-form-item label="" autocomplete="off" style="width: 150px !important; float: left; margin-left: 12px;" :prop="'properties.' + p + '.type'" :rules="{required: true, message: '请选择属性类型', trigger: 'change'}">
                                            <el-select v-model="properties.type" placeholder="请选择属性类型" @change="changeType(properties,'editCascader'+i+p)" >
                                                <el-option :value="1" label="产品属性" :disabled="ruleForm.function == 'time'||ruleForm.function == 'growth'"></el-option>
                                                <el-option :value="2" label="设备属性" :disabled="ruleForm.type==1||properties.groupType!=3"></el-option>
                                                <el-option :value="3" label="系统属性"></el-option>
                                                <el-option :value="4" label="数值"></el-option>
                                            </el-select>
                                          </el-form-item>

                                          <el-form-item label="" v-if="properties.type!=4" autocomplete="off" style="width: 150px !important; margin-left: 12px; float: left;" :prop="'properties.'+p+'.code'" :rules="{required: true, message: '请选择属性', trigger: 'change'}">
                                            <el-select v-model="properties.code" placeholder="请选择属性" @change="changeCode(properties)">
                                                <el-option
                                                :key="properties.VirtualDeviceCode"
                                                label="虚拟设备"
                                                :value="properties.VirtualDeviceCode"
                                                v-show="properties.type==2">
                                                </el-option>
                                                <el-option
                                                v-for="devObj in deviceList"
                                                :key="devObj.code"
                                                :label="devObj.name"
                                                v-if="orSuperior.type==3"
                                                :value="devObj.code">
                                                </el-option>
                                                <el-option
                                                v-for="devObj in systemList"
                                                :key="devObj.code"
                                                v-if="properties.type==3"
                                                :label="devObj.name"
                                                :value="devObj.code">
                                                </el-option>
                                                <el-option
                                                v-for="devObj in properties.deviceList"
                                                :key="devObj.code"
                                                v-if="properties.type==2&&orSuperior.type!=3"
                                                :label="devObj.name"
                                                :value="devObj.code">
                                                </el-option>
                                                <el-option
                                                v-for="devObj in allProductData"
                                                :key="devObj.code"
                                                v-if="properties.type==1"
                                                :label="devObj.name"
                                                :value="devObj.code">
                                                </el-option>
                                            </el-select>
                                          </el-form-item>
                                          <el-form-item label="" v-if="properties.type!=4" autocomplete="off" style="width: 150px !important; float: left; margin-left: 12px;" :prop="'properties.'+p+'.property'" :rules="{required: true, message: '请选择属性类型', trigger: 'change'}">
                                            <el-select v-model="properties.property" placeholder="请选择" @change="$forceUpdate()">
                                                <el-option
                                                v-for="devObj in properties.propertyData"
                                                :key="devObj.identifier"
                                                :label="devObj.name"
                                                :value="devObj.identifier"
                                                v-if="properties.code!=properties.VirtualDeviceCode"
                                                >
                                                </el-option>
                                                <el-option
                                                v-for="devObj in properties.VirtualFuncList"
                                                :key="devObj.identifier"
                                                :label="devObj.name"
                                                :value="devObj.identifier"
                                                v-if="properties.code==properties.VirtualDeviceCode"
                                                >
                                                </el-option>
                                            </el-select>
                                          </el-form-item>
                                          <el-form-item label="" v-if="properties.type==1&&properties.groupType==3" autocomplete="off" style="width: 150px !important; float: left; margin-left: 12px;" :prop="'properties.'+p+'.extend'" :rules="rules.groupType">
                                            <el-cascader
                                                :options="properties.DeviceGroup"
                                                :props="deviceGroupProps"
                                                v-model="properties.extend"
                                                :show-all-levels="false"
                                                v-if="properties.DeviceGroup"
                                            ></el-cascader>
                                          </el-form-item>

                                          <el-form-item label="" v-if="properties.type==4" autocomplete="off" style="width: 150px !important; float: left; margin-left: 12px;" :prop="'properties.'+p+'.extend'" :rules="{required: true, message:'请输入数值', trigger: 'change'}">
                                            <el-input v-model="properties.extend" @input="properties.extend=properties.extend.replace(/[^\-?\d.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"></el-input>
                                          </el-form-item>
                                          <span class="delAttr" @click="delproperties(p)" v-show="p>0">删除</span>
                                          <span class="delAttr disabled" v-show="p==0">删除</span>
                                      </el-form>
                                  </div>
                                  <span :class="[{'disabled':ruleForm.function=='time'},'add-enum']" @click="addProperties">+新增数据源</span>
                              </div>
                            </div>
                        </el-form>
                        <p class="popup-btn-box"><el-button type="primary" :disabled="!functionSet.includes('datasetEdit')||$store.state.isLook" id="editDataset" @click="updateDataset('editDatasetForm')">确定</el-button> <el-button @click="close('editDatasetShow')" id="closeEdit2">取消</el-button></p>
                    </div>
                </div>
                <!-- 验证码授权 -->
                <div class="popup-clear" v-show='functionShow' id="privilege" style="height: 349px;text-align: left;margin-left: -40%">
                    <div class="popup-title">
                        获取验证码授权<i><img :src="notes" title="提示" class="notes"></i><i class="el-icon-circle-close close" @click="close('functionShow')" id="closeClear3"></i>
                    </div>
                    <div class="popup-lab">
                        手机号：
                        <el-input disabled v-model="phone">{{phone}}</el-input>
                    </div>
                    <div class="popup-lab clearfix">
                        <p style="position: relative; left: -11px;"><i class="star">*</i>验证码：</p>
                        <el-form style="float: left; width: 255px;" :model="verifyForm" :rules="rules" ref="verifyCode" @submit.native.prevent>
                            <el-form-item prop="verifyCode">
                                <el-input id="verifyCode2" class="verifyCode" placeholder="请输入4位验证码" @keyup.enter.native="Privilege" v-model='verifyForm.verifyCode' maxlength="4" @input="verifyForm.verifyCode=verifyForm.verifyCode.replace(/[^\d]/g, '')"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="code-box">
                            <p class="get-code" v-show="getCodeShow" @click.stop='getCode' id="getCodeBtn2">获取验证码</p>
                            <p class="countdown" v-show="countdownShow">{{second}}S后重新获取</p>
                        </div>
                    </div>
                    <div class="popup-lab">
                        <p class="btn-box">
                            <el-button type="primary" @click="Privilege" id="toClear2">确定</el-button>
                            <el-button @click="close('functionShow')" id="closeClear4">取消</el-button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/PublicAssembly/pagination"
import Organize from "@/components/PublicAssembly/organize"
import unit from "@/assets/js/unit.json"
export default {
    data() {
        var valiName = (rule, value, callback) =>{      //数据集名称
            value = this.ruleForm.name
            // let reg=/^[A-Za-z0-9-_\u4e00-\u9fa5]{1,32}$/;
            if(value == "" ||value==null){
                callback(new Error('请输入数据集名称'));
            }else if(value.length>32){
                callback(new Error('数据集名称由1~32个字符构成'));
            }else{
                callback();
            }
        }
        var valiGroup= (rule, value, callback) =>{      //数据集名称
            callback();
        }
        var valiGroupType = (rule, value, callback) =>{      //数据源分组分支
            if(value == "" ||value==null){
                callback(new Error('请选择分组分支'));
            }else{
                callback();
            }
        }
        var ValTimeWindow = (rule, value, callback) =>{      //数据集名称
            if(this.ruleForm.frameType == 3){
                callback()
            }else if(this.ruleForm.timeWindow==null){
                callback(new Error('请选择时间粒度'))
            }else{
                callback()
            }
        }
        var valiBegin = (rule, value, callback) =>{      //数据集名称
            if(this.ruleForm.frameType==2){
                if(value){
                    callback()
                }else{
                    callback(new Error('请选择开始时间'))
                }
            }else{
                callback()
            }
        }
        var valiEnd = (rule, value, callback) =>{      //数据集名称
            if(this.ruleForm.frameType==2){
                if(value){
                    callback()
                }else{
                    callback(new Error('请选择结束时间'))
                }
            }else{
                callback()
            }
        }
        var valiplace = (rule, value, callback) =>{      //数据集名称
            if(value>16||value<0){
                callback(new Error('请输入0~16的数字'))
            }else{
                callback()
            }
        }
        var valiproperties = (rule, value, callback) =>{      //数据集名称
            // if(this.ruleForm.properties[0].code==null||this.ruleForm.properties[0].code==''){
            //     let i = this.ruleForm.properties[0].type
            //     if(i==1){
            //         callback(new Error('请选择产品'))
            //     }else if(i==2){
            //         callback(new Error('请选择设备'))
            //     }else{
            //         callback(new Error('请选择系统属性'))
            //     }
            // }if(this.ruleForm.properties[0].property==null||this.ruleForm.properties[0].property==''){
            //     let i = this.ruleForm.properties[0].type
            //     if(i==1){
            //         callback(new Error('请选择产品属性值'))
            //     }else if(i==2){
            //         callback(new Error('请选择设备属性值'))
            //     }else{
            //         callback(new Error('请选择系统属性值'))
            //     }
            // }else{
            //     callback()
            // }
            callback()
            // console.log(this.ruleForm.subset)
        }
        return {
            nullData:require('@/assets/image/index/nullData.png'),
            notes:require('@/assets/image/organize/notes.png'),
            down:require('@/assets/image/organize/down.png'),
            area:require('@/assets/image/company/qyzu.png'),
            branch:require('@/assets/image/company/ptzu.png'),
            location:require('@/assets/image/company/jczu.png'),
            dataset:require('@/assets/image/company/dataset.png'),
            dataset1:require('@/assets/image/company/dataset1.png'),
            roleTree:[],
            orCode:'',
            recoveryName:'',
            totalCount:1,
            pageSize:10,
            pageNumber:1,
            dataList:[],
            searchVal:"",
            state:0,
            addDatasetShow:false,
            editDatasetShow:false,
            delDatasetShow:false,
            setGroup:false,
            selectShow:false,
            nowObj:{},
            orSuperior:{},
            nowIndex:null,
            VirtualDevice:{},   //虚拟设备
            VirtualFuncList:[], //虚拟设备属性列表
            checkObj:[],        //多选
            unitData:[],        //单位数据
            allProductData:[],  //产品数据
            deviceList:[],      //设备数据
            systemList:[
                {name:'企业数',code:'_company'},
                {name:'用户数',code:'_user'},
                {name:'报警数',code:'_alarm'},
                {name:'故障时间',code:'_fault'},
                {name:'设备数',code:'_device'},
            ],
            defaultProps: {
              children: 'children',
              label: 'name'
            },
            pickerOptionsStart: {
                disabledDate: time => {
                    if (this.ruleForm.endFrame){
                        return time.getTime() > new Date(this.ruleForm.endFrame).getTime()
                    }
                }
            },
            pickerOptionsEnd: {
                disabledDate: time => {
                    if (this.ruleForm.beginFrame){
                        return time.getTime() < new Date(this.ruleForm.beginFrame).getTime() - 86400000
                    }
                }
            },
            ruleForm:{
                name:"",
                type:2,
                function:'sample',
                frameType:3,
                beginFrame:"",
                endFrame:"",
                timeWindow:1,
                unit:null,
                unitName:null,
                timeFrame:1,
                chartType:1,
                tableType:[],
                properties:[{type:1,code:null,property:null,propertyData:[]}],
                showLegend:false,
                showLabel:false,
                showData:false,
                showPercent:false,
                simple:1,
                place:2,
                ratio:1,
                categoryId:null,
                subset:[{
                  name:null,function:'sample',properties:[
                    {type:null,groupCode:null,groupType:1,code:null,property:null,extend:null,VirtualDeviceCode:-1,VirtualFuncList:[],deviceList:[],propertyData:[]}
                  ]
                }],

            },
            verifyForm:{
                verifyCode:'',
            },
            rules:{
                name:[{validator: valiName, required: true, trigger: 'blur'}],
                type:[{required: true,message:"请选择规则类型",trigger: 'submit'}],
                frameType:[{required: true,message:'',trigger: 'submit'}],
                categoryId:[{required: true,message:'请选择数据集类别',trigger: 'change'}],
                timeWindow:[{required: true,validator:ValTimeWindow,trigger: 'submit'}],
                group:[{required: true,validator: valiGroup,trigger: 'submit'}],
                verifyCode:[{ message: '请输入验证码', required: true, trigger: 'blur' }],
                beginFrame:[{ validator: valiBegin, required: true, trigger: 'change' }],
                endFrame:[{ validator: valiEnd, required: true, trigger: 'change' }],
                place:[{validator: valiplace, required: false, trigger: 'blur'}],
                properties:[{validator: valiproperties, required: false, trigger: 'blur'}],
                groupType:[{required: true,validator: valiGroupType,trigger: 'change'}]

            },
            orSuperiorData:[],
            roleId:null,
            functionSet:[],
            //系统属性值 对象
            company_arr:[   //企业数
                {name:'总数',identifier:'_company_total'},
                {name:'新增',identifier:'_company_newly'},
                {name:'在线',identifier:'_company_online'},
                {name:'停用',identifier:'_company_stop'},
            ],
            user_arr:[      //用户数
                {name:'总数',identifier:'_user_total'},
                {name:'新增',identifier:'_user_newly'},
                {name:'在线',identifier:'_user_online'},
                {name:'停用',identifier:'_user_stop'},
                {name:'冻结',identifier:'_user_freeze'},
            ],
            warning_arr:[   //报警树
                {name:'总数',identifier:'_alarm_total'},
                {name:'提示数量',identifier:'_alarm_level_infor'},
                {name:'警告数量',identifier:'_alarm_level_warm'},
                {name:'故障数量',identifier:'_alarm_level_error'},
            ],
            fault_arr:[     //故障时间
                {name:'响应时间',identifier:'_fault_response_time'},
                {name:'恢复时间',identifier:'_fault_recovery_time'},
            ],
            device_arr:[    //设备数
                {name:'总数',identifier:'_device_total'},
            ],
            functionShow:false,
            VerifyArr:[],
            verifyCode:'',
            second:60,
            getCodeShow:true,
            countdownShow:false,
            phone:'',
            time:null,
            cha:3,
            oldorSuperior:{},
            dataSetCategory:[], //有全部选项 - 查询
            CategoryList:[],    //无全部选项 - 编辑和新建
            optionProps: {
                value: 'id',
                label: 'name',
                children: 'children',
                expandTrigger: 'hover',
                code:"",
                emitPath:false,
            },
            groupProps:{
              value: 'code',
              label: 'name',
              children: 'children',
              checkStrictly: true,
              emitPath:false,
            },
            deviceGroupProps:{
              value: 'id',
              label: 'name',
              children: 'children',
              checkStrictly: true,
              emitPath:false,
            },
            categoryId:-1,
            subsetIndex:0,
            groupTree:[]
        }
    },
    components:{
        Pagination,
        Organize
    },
    created() {
        this.pageSize=this.$store.state.userConfig.rowsPerPage;
        this.$store.state.activeIndex = '/dataset'
        this.$store.state.mask = false
        this.getTree('a');
        this.unitData = unit;
        this.getProlist();
        this.getCategory()
        this.getwarnData()
        this.phone=this.hidePhone(this.$store.state.userData.mobile);
    },
    methods: {
        // 更新子集所属组
         changeGroup(obj,refName,noReset){
             let node = this.$refs[refName][0].getCheckedNodes(true)[0]
             if(node){
               obj.groupType = node.data.type
               if(node.data.type==3){
                 this.get('/Device/getList',{companyId:node.data.id}).then(res=>{
                   if(res.success){
                     obj.deviceList = res.result
                     if(!noReset){
                       obj.code = null
                       obj.property = null
                       obj.extend = null
                       obj.type = null
                       obj.propertyData=[]
                     }else{
                       if(obj.type>4){
                         if(obj.extend==0){
                           obj.type==5?obj.extend=-1:obj.extend=-2
                         }
                         obj.type=1
                       }
                       this.changeType(obj,refName)
                       this.changeCode(obj,true)
                     }
                   }else{
                     this.$message({
                       message: `获取企业设备列表失败:${res.message}`,
                       type: 'warning'
                     });
                   }
                 })
                 this.get('/VirtualDevice/get',{companyId:node.data.id}).then((res)=>{
                     if(res.success){
                          obj.VirtualDeviceCode = res.result.code
                          let parm = {deviceId:res.result.id,companyId:node.data.id}
                          this.get('/VirtualDevice/getPropertyList',parm).then((res)=>{
                              if(res.success){
                                  for(let obj2 of res.result){
                                      // obj2.dataType={type:'double',specs:[]}
                                      obj2.identifier = obj2.code
                                  }
                                  obj.VirtualFuncList = res.result
                              }else{
                                  this.$message({
                                      type:'warning',
                                      message:`获取企业虚拟设备属性列表失败：${res.message}`
                                  })
                              }
                          })
                     }else{
                          this.$message({
                             type:'warning',
                             message:`获取虚拟设备失败：${res.message}`
                          })
                     }
                 })
               }else if(noReset){
                 this.changeCode(obj,true)
               }
             }
             this.$forceUpdate()
             // console.log(obj)
         },
        // 添加子集
        addSubset(){
          if(this.ruleForm.subset.length>9){return }
          this.ruleForm.subset.push({
            name:null,function:'sample',properties:[
              {type:null,groupCode:this.orSuperior.code,groupType:this.orSuperior.type,code:null,property:null,extend:null,VirtualDeviceCode:-1,VirtualFuncList:[],deviceList:[],propertyData:[]}
            ]
          })
        },
        delSubset(i){
          this.ruleForm.subset.splice(i,1)
          if(i==this.subsetIndex){
            this.subsetIndex--
          }
        },
        // 获取分类
        getCategory() {
          this.get('/Category/getList', {
            type: 1
          }).then((res) => {
            if (res.success) {
              this.dataSetCategory = this.common.arrayToTree(res.result,'children')
              // console.log( this.dataSetCategory)
              for(let one of this.dataSetCategory){
                if(one.children){
                  for(let two of one.children){
                    if(!two.children){
                      two.disabled=true
                    }
                  }
                }else{
                  one.disabled = true
                }
              }
              this.CategoryList = this.clone(this.dataSetCategory)
              this.dataSetCategory.unshift({name:'全部',id:-1})
            } else {
              this.$message({
                message: `获取数据集类别数据失败:${res.message}`,
                type: 'warning'
              });
            }
          })
        },
        // 获取列表
        getlist(parm){
            if(parm.categoryId==-1){
              parm.categoryId = null
            }
            this.get('/v2/Dataset/query',parm).then((res)=>{
                if(res.success){
                    this.dataList=res.result.data
                    this.totalCount = res.result.totalCount
                }else{
                    this.$message({
                        message: `获取列表数据失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //获取组织树
        getTree(type){
            this.get('/Group/getOrganizationTree').then((res)=>{
                if(res.success){
                    // console.log(res.result)
                    this.roleTree=res.result;
                    this.orSuperior = this.roleTree[0]
                    this.oldorSuperior = this.clone(this.orSuperior)
                    this.orCode =  this.roleTree[0].code
                    this.$store.state.treeData = this.roleTree
                    this.functionSet = this.$store.state.treeData[0].functionSet.split(',')
                    this.$store.state.expandedArr=[]
                    this.expanded(this.$store.state.treeData,1)
                    if(type == 'a'){
                        this.roleId = this.$store.state.treeData[0].roleId
                        this.VerifyArr=localStorage.getItem('verifyCodeModule').split(',').map(Number)
                        this.getlist({pageNumber:1,length:Number(this.pageSize),code:this.orSuperior.code,keyword:this.searchVal})
                    }
                    this.orSuperiorData=[]  //初始化树
                    for(let obj of res.result){
                        if(obj.roleId == this.roleId){  //获取当前角色下树数据
                            obj = this.clone(obj)
                            this.orSuperiorData.push(obj)
                            this.groupTree = [obj]
                            return
                        }
                    }
                }else{
                    this.$message({
                        type:'warning',
                        message:`获取组织数据失败：${res.message}`
                    })
                }
            })
        },
        //获取所有产品
        getProlist(){
            this.get('/Product/getList').then((res)=>{
                if(res.success){
                    this.allProductData=res.result;
                    for(let item of res.result){
                        let obj ={
                            name:item.name,
                            identifier:'_device_product_'+ item.code
                        }
                        this.device_arr.push(obj)
                    }
                    // console.log(this.device_arr)
                }else{
                    this.$message({
                        message: `获取产品数据失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 获取报警分类
        getwarnData(){
            this.get('/Dict/getListByType',{type:2}).then((res)=>{
                // this.warnData=res.result
                // console.log(res.result)
                for(let item of res.result){
                    let obj ={
                        name:item.name,
                        identifier:'_alarm_category_'+item.id
                    }
                    this.warning_arr.push(obj)
                }
            })
        },
        //获取设备列表
        getdeviceList(id){
            this.get('/Device/getList',{companyId:id}).then((res)=>{
                if(res.success){
                    this.deviceList = res.result
                }else{
                    this.$message({
                        message: `获取设备数据失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        //获取指定企业的虚拟设备
        getVirtualDevice(id){
            this.get('/VirtualDevice/get',{companyId:id}).then((res)=>{
                if(res.success){
                    this.VirtualDevice = res.result
                    this.getVirtualFuncList()
                }else{
                    this.$message({
                        type:'warning',
                        message:`获取虚拟设备失败：${res.message}`
                    })
                }
            })
        },
        //获取虚拟设备的属性列表
        getVirtualFuncList(){
			if(!this.VirtualDevice.id&&this.VirtualDevice.id!=0){ return }
            let parm = {deviceId:this.VirtualDevice.id,companyId:this.companyId}
            this.get('/VirtualDevice/getPropertyList',parm).then((res)=>{
                if(res.success){
                    for(let obj of res.result){
                        obj.dataType={type:'double',specs:[]}
                        obj.identifier = obj.code
                    }
                    this.VirtualFuncList = res.result
                    // console.log(this.VirtualFuncList)
                }else{
                    this.$message({
                        type:'warning',
                        message:`获取虚拟设备属性列表失败：${res.message}`
                    })
                }
            })
        },
        //修改树组织
        setTree(){
            this.getTree()
        },
        // 获取的当前组
        setOrId(node){
            this.functionSet = node[1]
            // if(this.orCode == node[0].code){
            //     return
            // }
            if(node[0].roleId != this.roleId){
                this.roleId = node.roleId
                this.orSuperiorData = []
                for(let obj of this.$store.state.treeData){
                    if(node[0].roleId == obj.roleId){   //获取当前角色下的树数据
                        obj = this.clone(obj)
                        this.orSuperiorData.push(obj)
                        this.groupTree=[obj]
                    }
                }
            }
            this.checkObj = [];
            this.orCode=node[0].code;
            this.orSuperior=node[0];
            this.oldorSuperior = this.clone(this.orSuperior)
            this.isCount=true;
            this.searchVal='',
            this.pageNumber = 1
            this.search()
        },
        // 展开上级组
        showSelect(){
            var box = this.$refs.selectbox;
            this.selectShow=true;
        },
        // 获取用户点击的上级组节点
        selectId(data){
            if(this.orSuperior.code==data.code){
                this.selectShow=false;
                return
            }
            this.orSuperior= data;
            this.groupTree = [data]
            this.selectShow=false;
            let groupCode = null,deviceList=[]
            // console.log(data)
            if(data.type==3){
              groupCode = data.code
              this.get('/Device/getList',{companyId:data.id}).then(res=>{
                if(res.success){
                  this.deviceList = res.result
                  deviceList = res.result
                }else{
                  this.$message({
                    message: `获取企业设备列表失败:${res.message}`,
                    type: 'warning'
                  });
                }
              })
            }
            for(let i in this.ruleForm.subset){
              for(let l in this.ruleForm.subset[i].properties){
                this.$set(this.ruleForm.subset[i].properties,l,{
                  type:null,
                  groupCode:groupCode,
                  groupType:data.type,
                  code:null,
                  property:null,
                  extend:null,
                  propertyData:[],
                  deviceList:deviceList
                })
              }
            }
            if(data.type!=3){
                // this.reSetData()
            }else{
                // this.reSetData()
                this.getVirtualDevice(data.id)
                for(let obj of this.ruleForm.properties){
                    if(obj.type==2){
                        obj.property = null,
                        obj.code=null
                    }
                }
                this.get('/Device/getList',{companyId:data.id}).then((res)=>{
                    if(res.success){
                        this.deviceList = res.result
                    }else{
                        this.$message({
                            type:'warning',
                            message:`获取设备列表失败：${res.message}`
                        })
                    }
                })
            }
            this.$forceUpdate()
        },
        // 修改分页size
        setSize(pageObj){
            this.pageSize=pageObj.size;
            let parm = {
                pageNumber:this.pageNumber,
                length:this.pageSize,
                code:this.orCode,
                keyword:this.searchVal,
                categoryId:this.categoryId
            }
            switch(this.state){
                case 1:
                    parm.state=1;
                    break;
                case 2:
                    parm.state=2;
                    break;
                case 3:
                    parm.type=1;
                    break;
                case 4:
                    parm.type=2;
            }
            this.getlist(parm);

        },
        // 修改页数
        setNum(number){
            //主动修改页数不发送请求
            // console.log(number)
            this.pageNumber=number;
            if(this.setGroup){
                this.setGroup = false;
                return
            }
            let parm = {
                pageNumber:this.pageNumber,
                length:this.pageSize,
                code:this.orCode,
                keyword:this.searchVal,
                categoryId:this.categoryId
            }
            switch(this.state){
                case 1:
                    parm.state=1;
                    break;
                case 2:
                    parm.state=2;
                    break;
                case 3:
                    parm.type=1;
                    break;
                case 4:
                    parm.type=2;
            }
            this.getlist(parm);
        },
        // 头部标签
        headClick(i){
            // console.log(this.orCode)
            this.isCount = true
            let parm = {
                pageNumber:this.pageNumber,
                length:this.pageSize,
                code:this.orCode,
                keyword:this.searchVal,
                categoryId:this.categoryId
            }
            this.state = i
            switch(i){
                case 1:
                    parm.state=1;
                    break;
                case 2:
                    parm.state=2;
                    break;
                case 3:
                    parm.type=1;
                    break;
                case 4:
                    parm.type=2;
            }
            this.getlist(parm);
        },
        //搜索
        search(){
            this.isCount = true
            let parm = {
                pageNumber:this.pageNumber,
                length:this.pageSize,
                code:this.orCode,
                keyword:this.searchVal,
                categoryId:this.categoryId
            }
            switch(this.state){
                case 1:
                    parm.state=1;
                    break;
                case 2:
                    parm.state=2;
                    break;
                case 3:
                    parm.type=1;
                    break;
                case 4:
                    parm.type=2;
            }
            this.getlist(parm);
        },
        // 验证权限
        testFunc(obj){
            if(obj.type==1&&this.functionSet.includes('datasetEdit')&&this.functionSet.includes('datasetNormal')){
                return true
            }else if(obj.type==2&&this.functionSet.includes('datasetEdit')){
                return true
            }else{
                return false
            }
        },
        // 生成报表
        createdExcel(){
			// if(this.$store.state.isLook)return;
            if(this.checkObj.length > 0){
            	let arr = JSON.parse(JSON.stringify(this.checkObj.filter(item => item.state != 2)))
            	for(let a of arr){
            		if(a.type == 1){
            			a.groupCode = this.orSuperior.code
            		}
            	}
            	sessionStorage.setItem('DataSetList', JSON.stringify(arr))
                this.windowOpen('/dataset/createdCharts', '_blank')
            }else{
            	this.$alert('至少选择一条数据集生成报表', '信息', {
					confirmButtonText: '确定'
				});
            }

        },
        // 打开弹窗
        operate(obj,name,i){
            if(name!='editDatasetShow'&&!this.functionSet.includes('datasetEdit')||name!='editDatasetShow'&&!this.testFunc(obj)||name!='editDatasetShow'&&this.$store.state.isLook){
                return
            }
            if(this.VerifyArr.includes(7)&&!this.$store.state.isLook&&obj.type==1&&this.functionSet.includes('datasetNormal')){
                this.functionShow = true
                this.$store.state.mask=true
                return
            }
            this.nowObj = obj;
            this.nowIndex = i;
            if(name=='addDatasetShow'){
              this.ruleFrom = this.$options.data().ruleFrom
              this[name]=true;
              if(this.subsetIndex!=0&&this.ruleForm.simple==1){
                this.subsetIndex = 0
              }
              this.$store.state.mask=true;
              this.$refs.addDatasetForm.clearValidate()
              this.$refs.addDataOrigin.forEach(item=>{item.clearValidate()})
              this.$forceUpdate()
            }
            if(name=='editDatasetShow'){
                this.get('/v2/Dataset/get',{id:this.nowObj.id}).then((data)=>{
                    if(data.success){
                        let res = data.result,self=this
                        res.subset=JSON.parse(res.subset)
                        this.ruleForm = res
                        if(this.subsetIndex!=0&&this.ruleForm.simple==1){
                          this.subsetIndex = 0
                        }
                        this[name]=true;
                        this.$store.state.mask=true;
                        if(res.type==2){
                            let getTreeType = function(tree,code){
                              tree.forEach(e => {
                                  if (e.code === code) {
                                    self.orSuperior = e
                                    self.groupTree = [e]
                                    if(e.type==3){
                                      self.get('/Device/getList',{companyId:e.id}).then(res=>{
                                        if(res.success){
                                          self.deviceList = res.result
                                        }else{
                                          self.$message({
                                            message: `获取企业设备列表失败:${res.message}`,
                                            type: 'warning'
                                          });
                                        }
                                      })
                                    }
                                  }  // 某一项的id 等于 传入的id 就把该数组找出来
                                  if (e.children&&e.children.length > 0) {
                                      getTreeType(e.children, code)
                                  }
                              })
                            }
                            getTreeType(this.orSuperiorData,res.groupCode)
                        }
                        // console.log( this.orSuperior)
                        self.$nextTick(()=>{
                          for(let i in this.ruleForm.subset){
                            for(let p in this.ruleForm.subset[i].properties){
                              // console.log(this.ruleForm.subset[i].properties[p])
                              this.changeGroup(this.ruleForm.subset[i].properties[p],'editCascader'+i+p,true)
                              if(i==this.ruleForm.subset.length-1&&p==this.ruleForm.subset[i].properties.length-1){
                                this.$forceUpdate()
                                this.$refs.editDatasetForm.clearValidate()
                                this.$refs.editDataOrigin.forEach(item=>{item.clearValidate()})
                              }
                            }
                          }
                        })
                    }else{
                        this.$message({
                            type:'warning',
                            message:`获取数据集失败：${data.message}`
                        })
                    }
                })
                return
            }else{
              this[name]=true;
              this.$store.state.mask=true;
            }
        },
        // 关闭弹窗
        close(name){
            this.verifyForm.verifyCode = ''
            this[name]=false;
            this.$store.state.mask=false;
        },
        // 监听时间类型变化
        changeFrameType(){
            this.changeTimeFrame(this.ruleForm.timeFrame)
        },
        // 开始时间变化
        beginDate(val){
            if(this.ruleForm.endFrame){
                let a = new Date(val+' 00:00:00').getTime(),b = new Date(this.ruleForm.endFrame+' 23:59:59').getTime()
                let c = Math.ceil((b-a)/ (1000*3600*24))
                if(c>7&&c<32){
                    this.cha = 4
                    // if(this.ruleForm.timeWindow<2){
                    //     this.ruleForm.timeWindow=2
                    // }
                }else if(c>31){
                    this.cha = 5
                    if(this.ruleForm.timeWindow<3){
                        this.ruleForm.timeWindow=3
                    }
                }else{
                    this.cha = 3
                    if(this.ruleForm.timeWindow>3){
                        this.ruleForm.timeWindow=3
                    }
                }
                this.$forceUpdate()
            }
        },
        // 开始时间变化
        endDate(val){
            if(this.ruleForm.beginFrame){
                let b = new Date(val+' 23:59:59').getTime(),a = new Date(this.ruleForm.beginFrame+' 00:00:00').getTime()
                let c = Math.ceil((b-a)/ (1000*3600*24))
                if(c>7&&c<32){
                    this.cha = 4
                    // if(this.ruleForm.timeWindow<2){
                    //     this.ruleForm.timeWindow=2
                    // }
                }else if(c>31){
                    this.cha = 5
                    if(this.ruleForm.timeWindow<3){
                        this.ruleForm.timeWindow=3
                    }
                }else{
                    this.cha = 3
                    if(this.ruleForm.timeWindow>3){
                        this.ruleForm.timeWindow=3
                    }
                }
                // console.log(c,this.cha)
                this.$forceUpdate()
            }
        },
        // 监听相对时间变化
        changeTimeFrame(i){
            // console.log(i,this.ruleForm.timeWindow)
            if((this.ruleForm.timeWindow==i||this.ruleForm.timeWindow==i-1||this.ruleForm.timeWindow==i+1)&&this.ruleForm.timeWindow<=i){
                return
            }

            if(this.ruleForm.timeWindow>i||this.ruleForm.timeWindow>i-2){
                this.ruleForm.timeWindow = i-2<=0?1:i-2
            }else if(this.ruleForm.timeWindow<i-2){
                this.ruleForm.timeWindow = i-2<=0?1:i-2
            }
        },
        addDataset(){
            // console.log('qwdeqwd')
            this.cha = 3
            this.$refs.addDatasetForm.clearValidate()
            this.$refs.addDatasetForm.resetFields()
            this.$refs.addDataOrigin.forEach(item=>{item.clearValidate()})
            this.orSuperior = this.clone(this.oldorSuperior)
            if(this.orSuperior.type ==3){
                this.getdeviceList(this.orSuperior.id)
                this.getVirtualDevice(this.orSuperior.id)
            }
            this.ruleForm.subset =[{
                  name:null,function:'sample',properties:[
                    {type:null,groupCode:this.orSuperior.code,groupType:this.orSuperior.type,code:null,property:null,extend:null,VirtualDeviceCode:-1,VirtualFuncList:[],deviceList:[],propertyData:[]}
                  ]
                }],
            this.subsetIndex = 0
            this.addDatasetShow=true;
            this.$store.state.mask=true;
            this.$forceUpdate()
        },
        // 删除数据集
        delDataset(){
            this.get('/v2/Dataset/remove',{id:this.nowObj.id}).then((res)=>{
                if(res.success){
                    this.$message({
                        message:"删除成功",
                        type:"success"
                    })
                    this.search()
                }else{
                    this.$message({
                        message:`删除失败：${res.message}`,
                        type:"warning"
                    })
                }
                this.$store.state.mask=false;
                this.delDatasetShow =false
            })
        },
        // 创建数据集
        createdDataset(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let data = this.clone(this.ruleForm),errList=[]
                    for(let i in this.$refs.addDataOrigin){
                      this.$refs.addDataOrigin[i].validate((valid) => {
                        if(!valid){
                          errList.push(Number(i)+1)
                        }
                      })
                    }
                    if(errList.length){
                      this.$message({
                          message:`请输入完整各个子集的数据源`,
                          type:"warning"
                      })
                    }else{
                      let parm={
                          name:data.name,
                          type:data.type,
                          simple:data.simple,
                          categoryId:data.categoryId,
                          function:data.function,
                          place:data.place==''||data.place==null?null:Number(data.place),
                          unit:data.unit,
                          unitName:data.unitName,
                          subset:data.subset
                      }
                      if(parm.type==2){ //自定义
                          parm.groupCode=this.orSuperior.code
                          parm.groupName=this.orSuperior.name
                      }else{
                          parm.groupCode=''
                      }
                      // 格式化子集
                      let subset=[]
                      // 遍历子集数组 - item
                      for(let item of data.subset){
                        let obj={
                          name:item.name,
                          function:item.function
                        }
                        let arr=[]
                        // 子集数据源 - propertie
                        for(let propertie of item.properties){
                          let obj2={
                            type:propertie.type,
                            groupCode:propertie.groupCode,
                            code:propertie.code,
                            property:propertie.property,
                            extend:propertie.extend,
                          }
                          if(propertie.groupType==3&&propertie.type==1){
                            let getTreeType = function(tree,id){
                              tree.forEach(e => {
                                  if (e.id === id) { obj2.type = e.type+4}  // 某一项的id 等于 传入的id 就把该数组找出来
                                  if (e.children&&e.children.length > 0) {
                                      getTreeType(e.children, id)
                                  }
                              })
                            }
                            getTreeType(propertie.DeviceGroup,propertie.extend)
                          }
                          if((obj2.type==5||obj2.type==6)&&obj2.extend<0){
                            obj2.extend = 0
                          }
                          arr.push(obj2)
                        }
                        obj.properties = arr
                        subset.push(obj)
                      }
                      if(parm.simple==1){
                        subset = [subset[0]]
                      }
                      parm.subset = JSON.stringify(subset)
                      this.postNoJson('/v2/Dataset/create',parm).then((res)=>{
                          if(res.success){
                              this.$message({
                                  type:'success',
                                  message:'创建数据集成功'
                              })
                              this.search()
                              this.addDatasetShow =false;
                              this.$store.state.mask=false
                              this.ruleForm=this.$options.data().ruleForm
                              this.$forceUpdate()
                          }else{
                              this.$message({
                                  type:'warning',
                                  message:`创建数据集失败：${res.message}`
                              })
                          }
                      })
                    }
                }
            })
        },
        // 编辑数据集
        updateDataset(name){
            this.$refs[name].validate((valid) => {
                if(valid){
                    let data = this.clone(this.ruleForm),errList=[]
                    for(let i in this.$refs.addDataOrigin){
                      this.$refs.addDataOrigin[i].validate((valid) => {
                        if(!valid){
                          errList.push(Number(i)+1)
                        }
                      })
                    }
                    if(errList.length){
                      this.$message({
                          message:`请输入完整各个子集的数据源`,
                          type:"warning"
                      })
                    }else{
                      let parm={
                          id:data.id,
                          name:data.name,
                          type:data.type,
                          simple:data.simple,
                          categoryId:data.categoryId,
                          function:data.function,
                          place:data.place==''||data.place==null?null:Number(data.place),
                          unit:data.unit,
                          unitName:data.unitName,
                          subset:data.subset
                      }
                      if(parm.type==2){ //自定义
                          parm.groupCode=this.orSuperior.code
                          parm.groupName=this.orSuperior.name
                      }else{
                          parm.groupCode=''
                      }
                      // 格式化子集
                      let subset=[]
                      // 遍历子集数组 - item
                      for(let item of data.subset){
                        let obj={
                          name:item.name,
                          function:item.function
                        }
                        let arr=[]
                        // 子集数据源 - propertie
                        for(let propertie of item.properties){
                          let obj2={
                            type:propertie.type,
                            groupCode:propertie.groupCode,
                            code:propertie.code,
                            property:propertie.property,
                            extend:propertie.extend,
                          }
                          if(propertie.groupType==3&&propertie.type==1){
                            let getTreeType = function(tree,id){
                              tree.forEach(e => {
                                  if (e.id === id) { obj2.type = e.type +4}  // 某一项的id 等于 传入的id 就把该数组找出来
                                  if (e.children&&e.children.length > 0) {
                                      getTreeType(e.children, id)
                                  }
                              })
                            }
                            getTreeType(propertie.DeviceGroup,propertie.extend)
                          }
                          if((obj2.type==5||obj2.type==6)&&obj2.extend<0){
                            obj2.extend = 0
                          }
                          arr.push(obj2)
                        }
                        obj.properties = arr
                        subset.push(obj)
                      }
                      if(parm.simple==1){
                        subset = [subset[0]]
                      }
                      parm.subset = JSON.stringify(subset)
                      this.postNoJson('/v2/Dataset/update',parm).then((res)=>{
                          if(res.success){
                              this.$message({
                                  type:'success',
                                  message:'修改数据集成功'
                              })
                              this.search()
                              this.editDatasetShow = false;
                              this.$store.state.mask = false
                              this.ruleForm=this.$options.data().ruleForm
                              this.$forceUpdate()
                          }else{
                              this.$message({
                                  type:'warning',
                                  message:`修改数据集失败：${res.message}`
                              })
                          }
                      })
                    }
                }
            })
        },
        // 遍历分组树获取type


        // 修改数据源
        changeType(obj,refName){
            if(obj.groupType==3&&obj.type==1){
              let node = this.$refs[refName][0].getCheckedNodes(true)[0]
              let arr = [
                {name:"分组",type:1,id:-1,children:[]},
                {name:"分支",type:2,id:-2,children:[]}
              ]
              this.get('/DeviceGroup/getTree',{companyId:node.data.id,type:1}).then(res=>{
                if(res.success){
                  arr[0].children = res.result
                }else{
                  this.$message({
                      type:'warning',
                      message:`获取企业设备分组失败：${res.message}`
                  })
                }
              }).then(()=>{
                this.get('/DeviceGroup/getTree',{companyId:node.data.id,type:2}).then(res=>{
                  if(res.success){
                    arr[1].children = res.result
                  }else{
                    this.$message({
                        type:'warning',
                        message:`获取企业设备分支失败：${res.message}`
                    })
                  }
                })
              }).then(()=>{
                this.$set(obj,'DeviceGroup',arr)
                this.$forceUpdate()
              })

            }
        },
        // 修改数据集类型
        changeRuleType(i){
            if(this.subsetIndex!=0&&this.ruleForm.simple==1){
              this.subsetIndex = 0
            }
            if(this.ruleForm.simple==2&&(this.ruleForm.function == 'growth'||this.ruleForm.function=='ratio')){
              this.ruleForm.function = 'sample'
            }
            if(i==1){
              this.reSetData()
            }
        },
        // 重置数据源
        reSetData(){
            if(this.ruleForm.properties){
              for(let obj of this.ruleForm.properties){
                  if(obj.type==2){
                      obj.type=3;
                      obj.property = null,
                      obj.code=null
                  }
              }
            }
        },
        // 删除数据源
        delproperties(i){
            this.ruleForm.subset[this.subsetIndex].properties.splice(i,1)
        },
        // 修改code
        changeCode(obj,noReset){
            // console.log(obj)
            if(!noReset){
                obj.property = null
            }
            if(obj.type==1){
                this.get('/ProductFeature/get',{code:obj.code}).then((res)=>{
                    //json转换
                    if(res.success){
                        let proFunction=JSON.parse(res.result)
                        // obj.propertyData = proFunction.properties
                        this.$set(obj,'propertyData',proFunction.properties)
                        // console.log(obj)
                    }
                })
            }else if(obj.type==2){
                if(obj.code == obj.VirtualDeviceCode){
                    this.$forceUpdate()
                }else{
                    let devObj
                    if(this.orSuperior.type==3){
                      devObj = this.deviceList.filter(dev=>dev.code==obj.code)[0]
                    }else{
                      if(obj.deviceList){
                        devObj = obj.deviceList.filter(dev=>dev.code==obj.code)[0]
                      }
                    }
                    this.get('/ProductFeature/getByDeviceCode',{code:obj.code}).then((res)=>{
                        //json转换
                        if(res.success){
                            let proFunction=JSON.parse(res.result)
                            let arr = devObj.propertySet.split(',')
                            let attrarr = []
                            for(let obj of proFunction.properties){
                                if(arr.includes(obj.identifier)){
                                    attrarr.push(obj)
                                }
                            }
                             // obj.propertyData = attrarr
                            this.$set(obj,'propertyData',attrarr)
                            this.$forceUpdate()
                        }
                    })
                }

            }else{
                // console.log(obj)
                switch(obj.code){
                    case '_company':
                        this.$set(obj,'propertyData',this.company_arr);
                        break;
                    case '_user':
                        this.$set(obj,'propertyData',this.user_arr);
                        break;
                    case '_alarm':
                        this.$set(obj,'propertyData',this.warning_arr);
                        break;
                    case '_fault':
                        this.$set(obj,'propertyData',this.fault_arr);
                        break;
                    case '_device':
                        this.$set(obj,'propertyData',this.device_arr);
                        break;
                }
                this.$forceUpdate()
            }
        },
        // 修改函数
        changeFunction(val){
            if(val=='growth'){
                this.ruleForm.properties=this.ruleForm.properties.slice(0,1)
                this.ruleForm.properties[0].type=3
                this.ruleForm.properties[0].code=null
                this.ruleForm.properties[0].property=null
                this.ruleForm.properties[0].propertyData=[]
            }else if(val=='time'){
                this.ruleForm.properties=this.ruleForm.properties.slice(0,1)
                this.ruleForm.showLegend = false
            }
            if(val=='add'&&this.ruleForm.chartType==1){
                this.ruleForm.chartType=2
            }
            if(val=="time"||val == 'growth'){
                for(let obj of this.ruleForm.properties){
                    if(obj.type==1){
                        obj.type=3
                    }
                }
            }
            if(this.ruleForm.type==1){
                for(let obj of this.ruleForm.properties){
                    if(obj.type==2){
                        obj.type=3
                    }
                }
            }
            if(this.orSuperior.type!=3){
                for(let obj of this.ruleForm.properties){
                    if(obj.type==2){
                        obj.type=3
                    }
                }
            }
        },
        // 修改单位
        chanegUnit(val){
            for(let unitObj of this.unitData){
                if(unitObj.Symbol == val){
                    this.ruleForm.unitName = unitObj.Name
                }
            }
        },
        // 添加数据源
        addProperties(){
            let val = this.ruleForm.function
            if(val=='growth'||val=='time'){
                return
            }else{
                if(this.ruleForm.subset[this.subsetIndex].properties.length<10){
                    let obj = {type:null,code:null,property:null,propertyData:[],groupCode:this.orSuperior.code,groupType:this.orSuperior.type,VirtualDeviceCode:-1,VirtualFuncList:[],extend:null}
                    this.ruleForm.subset[this.subsetIndex].properties.push(obj)
                }else{
                    this.$message({
                    type:"warning",
                    message:"添加数据源失败，数据源最大长度为10个"
                })
                }
            }

        },
        // 获取验证码
        getCode(){
            this.get('/UserProfile/sendVerifyCode').then((res)=>{
                if(res.success){
                    this.getCodeShow=false
                    this.countdownShow=true
                    const TIME_COUNT = 60;
                    this.$message({
                        message: '验证码发送成功',
                        type: 'success'
                    });
                    if (!this.timer) {
                        this.second = TIME_COUNT;
                        this.show = false;
                        this.timer = setInterval(() => {
                            if (this.second > 0 && this.second <= TIME_COUNT) {
                                this.second--;
                            } else {
                                this.getCodeShow = true;
                                this.countdownShow=false;
                                clearInterval(this.timer);
                                this.timer = null;
                            }
                        }, 1000)
                    }
                }else{
                    this.$message({
                        message: `验证码发送失败：${res.message}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 用户提权
        Privilege(){
            this.$refs.verifyCode.validate((valid) => {
                if (valid) {
                    this.post('/UserProfile/privilege',{verifyCode:this.verifyForm.verifyCode}).then(res=>{
                        if(res.success){
                            this.$message({
                                message:'提权成功',
                                type:'success'
                            })
                            this.VerifyArr.splice(this.VerifyArr.indexOf(7),1)
                            localStorage.setItem('verifyCodeModule',this.VerifyArr)
                            this.$store.state.mask=false
                            this.functionShow=false
                            this.getCodeShow = true;
                            this.countdownShow=false;
                            clearInterval(this.timer);
                            this.timer = null;
                            this.verifyForm.verifyCode = ''
                        }else{
                            this.$message({
                                message:`提权失败：${res.message}`,
                                type:'warning'
                            })
                        }
                    })
                }
            })
        },
    },
    watch: {
        addDatasetShow(){
            if(!this.addDatasetShow){
                this.ruleForm = this.$options.data().ruleForm
            }
        },
        editDatasetShow(){
            if(!this.editDatasetShow){
                this.ruleForm = this.$options.data().ruleForm
            }
        },
    },
}
</script>
<style lang="scss" scoped>
  .add-state{
    float: right;
    color: #5087e4;
    cursor: pointer;
    &.disabled{
      color: #d2d2d2;
      cursor: not-allowed;
    }
  }
  .tabs-box2{
      float: left;
      height: 34px;
      overflow: hidden;
      background-color: #fff;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border: 1px solid #d2d2d2;
      border-bottom: 0;
      .del-icon{
        display: none;
        font-size: 14px;
        color: red;
        position: absolute;
        right: 2px;
        top: 2px;
        cursor: pointer;
      }
      div:hover{
        .del-icon{
          display: inline-block;
        }
      }
      div{
          float: left;
          padding: 9px 0;
          position: relative;
      }
      span{
          display: inline-block;
          width: 80px;
          font-size: 14px;
          line-height: 18px;
          border-left: 1px solid #e2e2e2;
          cursor:pointer;
          float: left;
          text-align: center;
      }
  }
  .tabs-box2>div:first-child span{
      border: none;
  }
</style>

<style scoped>
  .unit-select{
    width: 45%;
  }
  .name-box{
    padding:0 11px 5px;
    border-bottom: 1px solid #dedede;
    margin-bottom: 10px;
  }


    .tabs-box{
        float: left;
        height: 40px;
        overflow: hidden;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #d2d2d2;
        position: absolute;
        top:-43px;
    }
    .tabs-box div{
        float: left;
        padding: 9px 0;
    }
    .tabs-box span{
        display: inline-block;
        width: 110px;
        font-size: 14px;
        line-height: 22px;
        border-left: 1px solid #e2e2e2;
        cursor:pointer;
        float: left;
    }
    .tabs-box>div:first-child span{
        border: none;
    }
    .list-box{
        position: absolute;
        top: 36px;
        left: 328px;
        right: 0;
        bottom: 0;
    }
    .organize{
        position: absolute;
        top: 36px;
        bottom: 0;
    }
    .list-top{
        margin: 0px 16px 15px 16px;
        padding-top: 24px;
        height: 34px;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
    }
    .search{
        float: right;
        width: 268px;
        margin-right: 10px;
    }
    .search-btn{
        float: right;
    }
    .company-list{
        overflow: hidden;
        margin-bottom: 32px;
        height: 90%;
    }
    .scroll{
        overflow: auto;
        width: 97.6%;
        max-height: 88% !important;
        height: 88%;
        margin: 0 16px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 120px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
    }
    .w-15{
        width: 15% !important;
    }
    .w-18{
        width: 18% !important;
    }
    .list-details:last-child{
        border-bottom:1px solid #f2f2f2;
    }
    img.notes{
        position: relative;
        left: 5px;
        top: 5px;
    }
    .w-90{
        width: 90px !important;
        margin-right: 40px !important;
    }
    .active{
        background: #5087e4;
        color: #fff;
    }
    .active>span{
        border: 0;
    }
    .disabled3{
        background-color: #F5F7FA !important;
        color: #C0C4CC !important;
        cursor: not-allowed;
    }
    .bg{
        width: 100%;
        height: 90%;
    }
    /* 弹窗 */
    .popup>div{
        position: fixed;
        top: 10%;
        left:50%;
        padding:0 28px;
        box-sizing: border-box;
        margin-left:-571px;
        width: 578px;
        background-color: #fff;
        z-index: 999;
        padding-bottom: 30px;
        height: 285px;
        text-align: left;
    }
    .popup-title{
        font-size: 16px;
        line-height: 64px;
        border-bottom: 1px solid #e5e5e5;
        margin-bottom: 12px;
        text-align: left;
    }
    .popup-lab{
        font-size: 14px;
        line-height: 30px;
        margin-bottom: 14px;
    }
    .popup-btn-box{
        text-align: center;
        margin-top: 30px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 38px;
    }
    .popup-btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    i.close{
        font-size: 20px;
        float: right;
        margin-top: 24px;
    }
    img.notes{
        position: relative;
        left: 8px;
        top: 4px;
    }
    .b-32{
        position: absolute;
        bottom: 32px;
        left: 0;
    }
    .btn-box{
        position: absolute;
        text-align: center;
        bottom: 36px;
        width: 100%;
        left: 0;
    }
    .btn-box .el-button{
        padding: 0 34px !important;
        line-height: 34px !important;
        margin: 0 20px;
    }
    /* 新增 */
    .popup-addDataset{
        min-width: 1080px !important;
        height: 762px !important;
        margin-left: 0 !important;
        top: 50% !important;
        transform: translate(-65%,-55%);
        max-width: 1200px;
        width: 60%;
    }
    .ruleFrom-left,.ruleFrom-right{
        width: 47%;
        float: left;
    }
    .ruleFrom-left{
        margin-right: 5%;
    }
    .function{
        width: 100%;
    }
    .data-orange-box{
        height: 348px;
        border: 1px solid #dedede;
        background-color: #f8f8f8;
        overflow-y: auto;
        padding: 24px 0;
        box-sizing: border-box;
    }
    .or-Superior{
        height: 34px;
        line-height: 34px;
        border-radius: 5px;
        border: 1px solid #e5e5e5;
        padding:0 10px;
        position: relative;
        box-sizing: border-box;
        top:30px;
        margin-bottom:30px;
    }
    .or-Superior i{
        float: right;
    }
    .or-Superior img{
        width: 22px;
        margin-top: 6px;
    }
    .select-box{
        width: 100%;
        position: absolute;
        left: -1px;
        top: 32px;
        border: 1px solid #e5e5e5;
        max-height: 315px;
        overflow: auto;
        /* width: 370px; */
        border-radius: 5px;
        z-index: 99;
        background: #fff;
    }
    .select-box2{
      margin-right: 20px;
      font-size: 14px;
      line-height: 34px;
    }.
    .time-box{
        margin-top: 12px;
    }
    .m-l-10{
        margin-left: 10px;
    }
    .m-l-10>>>.el-radio{
      margin-right: 20px;
    }
    .m-l-10>>>.el-radio:last-child{
      margin-right: 0;
    }
    .coefficient{
        float: left;
        width: 82.5%;
        margin-left: 13px;
    }
    .place{
        width: 60px;
        margin: 0 5px;
    }
    .chartTitle{
        width: 70.5%;
    }
    .chartType{
        width: 76%;
    }
    .m-t-5{
        margin-top: 5px;
    }
    .inline-block{
        display: inline-block;
    }
    .attribute{
        width: 36%;
        margin-right: 6px;
    }
    .property-select{
        width: 74.5%;
    }
    .m-t-12{
        margin-top: 6px;
    }
    .orange-list{
        margin:0 11px 5px;
    }
    .add-enum{
        color: #5087e4;
        cursor: pointer;
        margin-left: 11px;
    }
    .p-a-l-10{
        position: absolute;
        left: 10px;
    }
    .delAttr{
        float: right;
        color: #5087e4;
        cursor: pointer;
    }
    .delAttr.disabled{
        color: #c3c3c3;
    }
    .min-120{
        min-width: 120px;
    }
</style>
<style>
    #dataset .popup .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }

    #dataset .orange-list .el-cascader{
        line-height: 34px !important;
    }
    #dataset .popup .el-form-item{
        width: 100% !important;
        margin-bottom: 11px !important;
    }
    #dataset .popup .w-30.el-form-item{
        width: 35% !important;
        float: left;
    }
    #dataset .popup .el-form-item__label{
        padding: 0 !important;
        color: #2f3a4e !important;
        line-height: 14px !important;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    #dataset .popup .el-form-item__content,#dataset .cascader.el-cascader,#dataset .search .el-icon-search,#dataset .popup .el-input__icon, #dataset .cascader .el-input__icon{
        line-height: 34px !important;
    }
    #dataset .popup .el-form-item.m-b-10 {
        margin-bottom: 10px !important;
    }
    #dataset .search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #dataset .popup .w-100 .el-form-item__label{
        text-align: left;
        width: 100% !important;
    }
    #dataset .popup .m-b-0.el-form-item{
        margin-bottom: 0 !important;
    }
    #dataset .popup .w-220.el-form-item{
        width: 220px !important;
    }
    #dataset .time .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px 0 25px!important;
    }
    #dataset .remarks textarea{
        width: 100%;
        height: 95px;
        border: 1px solid #dedede;
        resize: none;
        border-radius: 5px;
        padding:5px;
        box-sizing: border-box;
        line-height: 20px;
    }

    #dataset .cascader .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dataset/dataset.vue